import BaseModal from 'react-modal';
import React from 'react';
import classnames from 'classnames';

export default function Modal(props) {
    return (
        <BaseModal overlayClassName="modal-overlay" className={classnames('modal', props.className)} isOpen={props.isOpen}>
            {props.children}
        </BaseModal>
    );
}



// WEBPACK FOOTER //
// ./src/js/components/modal.js